import { Device } from "../../Types";

type DeviceFilterKeys = keyof Pick<Device, "showPSF" | "show13Plus">;

export type FilterConfig = {
  id: DeviceFilterKeys;
  label: string;
  errorPrefix: string;
};

export const FILTER_LIST: FilterConfig[] = [
  {
    id: "showPSF",
    label: "Filter Photo Sensitive Filter",
    errorPrefix: "Failed to update PSF Content",
  },
  {
    id: "show13Plus",
    label: "Filter 13+ Content",
    errorPrefix: "Failed to update 13+ Content",
  },
];

export type DeviceFilter = DeviceFilterKeys;
